import { AreaMeasurementDetails } from './AreaMeasurementDetails';
import { createAreaMeasurementController } from './area-measurement-controller';

export const areaMeasurementConfig = {
  detailsComponent: AreaMeasurementDetails,
  optionsComponent: undefined,
  createController: createAreaMeasurementController,
};

export type {
  AreaDetailsProps,
  AreaMeasurementController,
} from './area-measurement.types';
export type { AreaMeasurementDetailsProps } from './AreaMeasurementDetails';
export { AreaMeasurementDetails, createAreaMeasurementController };
